import styled from '@emotion/styled'
import {
  colors,
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogTitle as MuiDialogTitle,
  RadioGroup as MuiRadioGroup,
  typography,
} from '@resiliatech/birdsong'
import { Button as MuiButton } from '@material-ui/core'

export const Dialog = styled(MuiDialog, {
  shouldForwardProp: (prop) => prop !== 'isSingleTask',
})`
  .MuiDialog-paper {
    width: 768px;
    min-height: ${(props) => (props.isSingleTask ? '212px' : '346px')};
    padding: 24px 24px 24px 24px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
  }
`

export const DialogTitle = styled(MuiDialogTitle)`
  padding: 0;
  margin-bottom: 8px;
`

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const RadioGroup = styled(MuiRadioGroup)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const DialogActions = styled(MuiDialogActions)`
  display: flex;
  justify-content: space-between;
  padding: 0;
  margin-top: 16px;
`

export const Buttons = styled.div`
  display: flex;
  gap: 16px;
  min-height: 24px;
  margin-left: auto;
`

export const Button = styled(MuiButton, {
  shouldForwardProp: (prop) => prop !== 'addBorder',
})<{ addBorder?: boolean }>`
  ${typography.baseline.semiBoldSans}
  border-width: 1px;
  border-color: ${({ addBorder }) =>
    addBorder ? `rgba(0, 63, 126, 0.50)` : 'transparent'};
  padding: 8px 22px;
  min-width: 100px;
`

export const ErrorButton = styled(Button)`
  && {
    background-color: ${colors.feedback.errorDark};
    color: ${colors.common.white};

    &:hover {
      background-color: ${`${colors.feedback.errorDark}CC`};
    }
  }
`
